// @flow
import AppsUtil from './AppsUtil';
import DeviceDetectionUtil from './DeviceDetectionUtil';
import ThorUtil from './wam/ThorUtil';

class CompatibilityUtil {
	_checkCompatibility(sapCode: string, appData: Array<Object>) {
		if (sapCode === 'KCCC') {
			return {
				type : 'currentSupported',
				value: 'Current version supported',
				supportedAppVersion: appData[appData.length - 1].version
			};
		}
		if (this.isOSDeprecated()) {
			return {
				type : 'incompatible',
				value: 'Incompatible OS'
			};
		}
		return ThorUtil.getWAMClient().checkCompatibilityViaFFC(sapCode, appData);
	}

	// Check if latest version of app is supported on user OS
	isAppSupported(sapCode: string) {
		if (AppsUtil.hasFeature('bypass_compatibility_check')) {
			// This is for monitoring whcih run on Linux machines
			return true;
		}
		if (sapCode === 'KCCC' && DeviceDetectionUtil.isLinux()) {
			return false;
		}
		if (sapCode === 'KCCC') {
			return true;
		}
		if (this.isOSDeprecated()) {
			return false;
		}
		let appData;
		if (AppsUtil.appsFFCProductList && AppsUtil.appsFFCProductList[sapCode]) {
			appData = [AppsUtil.appsFFCProductList[sapCode]];
		}
		if (!appData) {
			return false;
		}
		const compatibilityInfo = this._checkCompatibility(sapCode, appData);
		return compatibilityInfo.type === 'currentSupported';
	}

	getSupportedAppVersion(sapCode: string) {
		if (AppsUtil.appsFFCProductList && AppsUtil.appsFFCProductList[sapCode]) {
			let appVersion = AppsUtil.appsFFCProductList[sapCode].version;
			if (!this.isAppSupported(sapCode) && this.isAnyOlderVersionSupported(sapCode)) {
				appVersion = AppsUtil.appsFFCProductList[sapCode].olderSupportedVersion;
			}
			return appVersion;
		}
		return null;
	}

	isAnyOlderVersionSupported(sapCode: string) {
		if (sapCode === 'KCCC' && DeviceDetectionUtil.isLinux()) {
			return false;
		}
		if (sapCode === 'SPRK') {
			return false;
		}
		if (AppsUtil.allVersionsFFCProductList && AppsUtil.allVersionsFFCProductList[sapCode]) {
			AppsUtil.printLog(`All version product data ${sapCode} ${AppsUtil.allVersionsFFCProductList[sapCode]}`);
			const compatibilityInfo = this._checkCompatibility(sapCode, AppsUtil.allVersionsFFCProductList[sapCode]);
			if (compatibilityInfo.type !== 'incompatible') {
				AppsUtil.appsFFCProductList[sapCode].olderSupportedVersion = compatibilityInfo.supportedAppVersion;
				return true;
			}
			return false;
		}
		return true;
	}

	// Check if creative cloud app is thor or ccd
	isCCDSupported() {
		/*
			CCD (new UI) is supported on Mac - 10.12 and greater. Win - Win7, Win10. Non-32-bit.
			Source: https://wiki.corp.adobe.com/pages/viewpage.action?spaceKey=CCEE&title=2020%2C+April+-+CCWeb+NUJ+Single+App+Plan+Queries
		*/
		let supported = false;
		if (DeviceDetectionUtil.isWin()) {
			const agent = navigator.userAgent.toLowerCase();
			const otherThanWin8 = agent.match(('Windows NT 6.2').toLowerCase()) || agent.match(('Windows NT 6.3').toLowerCase());
			supported = !(DeviceDetectionUtil.isDeprecatedWinOS() || (otherThanWin8 && otherThanWin8.length > 0));
		}
		else if (DeviceDetectionUtil.isMacOS()) {
			const macOS = DeviceDetectionUtil.getMacVersion();
			if (macOS && macOS !== null) {
				const macOSArr = macOS.split('.');
				supported = (parseInt(macOSArr[0], 10) > 10 || (parseInt(macOSArr[0], 10) === 10 && macOSArr[1] && parseInt(macOSArr[1], 10) >= 12));
			}
		}
		return supported;
	}

	isOSDeprecated() {
		if (DeviceDetectionUtil.isWin()) {
			return DeviceDetectionUtil.isDeprecatedWinOS();
		}
		else if (DeviceDetectionUtil.isMacOS()) {
			return DeviceDetectionUtil.isDeprecatedMacOS();
		}
		return false;
	}
}

export default new CompatibilityUtil();